import { useCallback, useEffect, useRef, useState } from 'react';
import { getDeal } from '@/services/deals.service.js';

// Single-deal fetcher for the focused deal in AccountWorkspace
// (URL pattern /account/:idOrSlug/deal/:dealId). Powers the
// DealActionBar's stage-aware affordances and the quote picker
// inside LogDeclineSheet.

export default function useDeal(dealId) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(!!dealId);
  const aborted = useRef(false);

  const refresh = useCallback(async () => {
    if (!dealId) return;
    setLoading(true);
    setError(null);
    try {
      const d = await getDeal(dealId);
      if (!aborted.current) setData(d);
    } catch (err) {
      if (!aborted.current) setError(err);
    } finally {
      if (!aborted.current) setLoading(false);
    }
  }, [dealId]);

  useEffect(() => {
    aborted.current = false;
    if (dealId) refresh();
    return () => {
      aborted.current = true;
    };
  }, [dealId, refresh]);

  return { data, error, loading, refresh };
}
